import { SIMPLEPRACTICE_CLIENT_PORTAL_URL } from '../../utils/simplePractice';

export const NAV_ITEMS = [
  { label: 'About', to: '/about' },
  { label: 'Our Practitioners', to: '/practitioners' },
  { label: 'Services', to: '/services' },
  { label: 'Your Journey', to: '/your-journey' },
  { label: 'Blog', to: '/blog' },
  // Client Portal now points straight to the SimplePractice sign-in page (external).
  { label: 'Client Portal', href: SIMPLEPRACTICE_CLIENT_PORTAL_URL, external: true },
];
